import React, { useState } from 'react'
import styled from 'styled-components'
import RouteContainer from '../../common/styles/RouteContainer'
import RowSpacer from '../../common/styles/RowSpacer'
import FaqData from './FaqData'
import parse from 'html-react-parser'
import useHtmlTitle from '../../common/useHtmlTitle'
import BooksitoutIcon from '../../config/BooksitoutIcon'

const FaqRoute = () => {
	useHtmlTitle('자주 묻는 질문')

	return (
		<RouteContainer>
			<RowSpacer />
			<RouteTitle>자주 묻는 질문</RouteTitle>
			<RouteSubTitle>
				자주 묻는 질문을 모았어요. 더 궁금한게 있으시면 언제든{' '}
				<a href={'mailto:support@booksitout.com'} className="text-book fw-bold">
					support@booksitout.com
				</a>
				으로 알려 주세요!
			</RouteSubTitle>

			<RowSpacer size={40} />
			<BoardContainer>
				{FaqData.map((faqDatum, index) => (
					<FaqBoardRow key={faqDatum.id} faq={faqDatum} isLast={index === FaqData.length - 1} defaultOpen={index === 0} />
				))}
			</BoardContainer>
			<RowSpacer size={40} />
		</RouteContainer>
	)
}

const FaqBoardRow: React.FC<{ faq: { id: number; question: string; answer: string }; isLast: boolean; defaultOpen?: boolean }> = ({ faq, isLast, defaultOpen = false }) => {
	const [isOpen, setIsOpen] = useState(defaultOpen)

	return (
		<BoardRow $isLast={isLast} $isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
			<BoardRowHeader $isOpen={isOpen}>
				<BoardRowTitle $isOpen={isOpen}><QBadge>Q</QBadge>{faq.question}</BoardRowTitle>
				<ChevronIcon $isOpen={isOpen}>
					<BooksitoutIcon.ArrowDown />
				</ChevronIcon>
			</BoardRowHeader>

			<BoardRowContentWrapper $isOpen={isOpen}>
				<BoardRowContentInner>
					<BoardRowContent>{parse(faq.answer)}</BoardRowContent>
				</BoardRowContentInner>
			</BoardRowContentWrapper>
		</BoardRow>
	)
}

const RouteTitle = styled.h1`
	font-size: 2rem;
	font-weight: bold;
	margin-top: 40px;
	padding-left: 24px;
`

const RouteSubTitle = styled.h5.attrs({
	className: 'text-secondary',
})`
	padding-left: 24px;
`

const BoardContainer = styled.div`
	border-radius: 16px;
	background-color: var(--card-bg-color);
	border: 1px solid rgba(0, 0, 0, 0.06);
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
	overflow: hidden;
`

const BoardRow = styled.div<{ $isLast: boolean; $isOpen: boolean }>`
	cursor: pointer;
	border-bottom: ${({ $isLast }) => ($isLast ? 'none' : '1px solid rgba(0, 0, 0, 0.06)')};
`

const BoardRowHeader = styled.div<{ $isOpen: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	padding: 20px 24px;
	transition: background-color 0.15s;
	background-color: ${({ $isOpen }) => ($isOpen ? 'var(--card-bg-color)' : 'transparent')};

	&:hover {
		background-color: var(--hover-bg-color);
	}
`

const BoardRowTitle = styled.span<{ $isOpen: boolean }>`
	font-size: 16px;
	font-weight: 600;
	color: ${({ $isOpen }) => ($isOpen ? 'var(--primary-color)' : 'var(--text-color)')};
	transition: color 0.2s;
	flex: 1;
`

const QBadge = styled.span`
	color: var(--primary-color);
	font-weight: 700;
	margin-right: 10px;
	flex-shrink: 0;
`

const ChevronIcon = styled.span<{ $isOpen: boolean }>`
	display: flex;
	align-items: center;
	color: var(--sub-text-color);
	transition: transform 0.2s;
	transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
	font-size: 14px;
`

const BoardRowContentWrapper = styled.div<{ $isOpen: boolean }>`
	display: grid;
	grid-template-rows: ${({ $isOpen }) => ($isOpen ? '1fr' : '0fr')};
	transition: grid-template-rows 0.25s ease;
	overflow: hidden;
`

const BoardRowContentInner = styled.div`
	min-height: 0;
	overflow: hidden;
`

const BoardRowContent = styled.div`
	font-size: 15px;
	line-height: 1.7;
	color: var(--sub-text-color);
	background-color: var(--search-field-bg-color);
	padding: 12px 24px 20px;

	ul {
		padding-left: 20px;
		margin: 8px 0;
	}

	li {
		margin-bottom: 4px;
	}
`

export default FaqRoute
